import styled from "styled-components";
import { ReactComponent as Mp3DownIcon } from '../../svgs/mp3_down_icon.svg';
import { transition01 } from "../../style/mixins";
import Btn from "./Btn";
import { fileApiService } from "../../api/apiService";

interface Mp3BtnProps {
  size?: "sm" | "lg";
  path: string;
  fileName: string;
}

export default function Mp3Btn({ size = "sm", path, fileName }: Mp3BtnProps) {
  const getPdfDow = async () => {
    try {
      const response = await fileApiService.get<Blob>(path + "&down=1", {
        responseType: "blob" as ResponseType,
      });
      
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      throw error;
    }
  };
  
  return (
    <>
      {
        size === "sm" ? (
          <Mp3BtnStyle
            type="button"
            onClick={getPdfDow}
          >
            <Mp3DownIcon />
          </Mp3BtnStyle>
        ) : (
          <Btn
            type="button"
            color="mp3"
            title="녹음파일 다운로드"
            size={size}
            onClick={getPdfDow}
          />
        )
      }
    </>
  );
}

const Mp3BtnStyle = styled.button`
  background-color: #E8E8E8;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  ${transition01};

  &:hover {
    background-color: #cccccc;
  }
`;
